/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NotificationsInputs */



/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {NotificationsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notifications = /** @type {((inputs?: NotificationsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NotificationsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notifications")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benachrichtigungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Notifiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уведомления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notificaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("通知")
	if (locale === "ja") return /** @type {LocalizedString} */ ("通知")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूचनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notificações")
	return /** @type {LocalizedString} */ ("Notifications")
});